import { z } from "zod";

export const SlugSchema = z
  .string()
  .min(1)
  .max(120)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "lowercase letters, digits and single hyphens");

export const MediaRefSchema = z.object({
  /** cms_media id; the renderer resolves it to a URL at read time. */
  id: z.string().min(1),
  url: z.url().optional(),
  alt: z.string().max(300).default(""),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
});
export type MediaRef = z.infer<typeof MediaRefSchema>;

export const LinkSchema = z.object({
  label: z.string().min(1).max(80),
  href: z.string().min(1).max(2000),
  external: z.boolean().default(false),
  variant: z.enum(["primary", "secondary", "link"]).default("primary"),
});
export type Link = z.infer<typeof LinkSchema>;

/** Block-scoped id used by the editor's sortable list and by anchors. */
export const BlockIdSchema = z.string().min(1).max(64);
